import React, { useContext } from "react"
import useOptimizedImages from "../../utils/useOptimizedImages"
import replace from "../../utils/replace"
import pricePerDesk from "../../utils/pricePerDesk"
import priceRange from "../../utils/priceRange"
import qs from "query-string"
import moment from "moment-timezone"
import { differenceInMinutes, parse } from "date-fns"
import { SpaceProfileContext } from "../../components/SpaceProfile/context"
import countWorkingDays from "../../utils/countWorkingDays"
import mapPrice from "../../utils/mapPrice"

const ApiLocationBlock = ({
  location,
  user,
  city,
  onMouseEnter = () => null,
  onMouseLeave = () => null,
  displayPrice = false,
}) => {
  const {
    commonData: { holidays, isDaily },
  } = useContext(SpaceProfileContext)
  const spaceImage = useOptimizedImages(
    location.cover_image || location.image,
    960,
    600,
    600,
    600
  )
  const locationParams =
    typeof window !== "undefined" ? qs.parse(window.location.search) : {}
  const capacity = location.results
    .map((item) => item.capacity)
    .reduce(function (a, b) {
      return Math.max(a, b)
    })

  const days =
    locationParams &&
    locationParams.move_in_date &&
    locationParams.move_out_date
      ? countWorkingDays(
          parse(locationParams.move_in_date, "yyyy-MM-dd", new Date()),
          parse(locationParams.move_out_date, "yyyy-MM-dd", new Date()),
          holidays
        )
      : 1

  const hours =
    differenceInMinutes(
      parse(
        `${locationParams.move_in_date} ${locationParams.end_time}`,
        "yyyy-MM-dd h:mm a",
        new Date()
      ),
      parse(
        `${locationParams.move_in_date} ${locationParams.start_time}`,
        "yyyy-MM-dd h:mm a",
        new Date()
      )
    ) / 60

  const count = isDaily ? days : hours

  return (
    <ProfileLink
      className="location-box"
      href={profileUrl(location.space_id, user)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="row">
        <div className="col-sm-6">
          <div className="img">
            <img src={spaceImage} alt="" />
          </div>
        </div>
        <div className="col-sm-6 d-flex">
          <div className="desc-block">
            <span className={"address"}>
              {location.location && location.location.short_address}
            </span>
            <h4>{replace(location.name)}</h4>
            <p className={"available-solutions"}>
              {location.type === "bundle" && (
                <span>{location.bundle_description}</span>
              )}

              {location.type !== "bundle" &&
                user.offices &&
                location.type === "office" &&
                location.count > 1 && (
                  <>
                    <span>Private office</span>
                    <span>2 Options</span>
                    <span>
                      {Number(location.capacity) === 1
                        ? "1 person"
                        : `Up to ${capacity} people`}
                    </span>
                  </>
                )}
              {location.type !== "bundle" &&
                user.offices &&
                location.type === "office" &&
                location.count === 1 && (
                  <>
                    <span>Private office</span>
                    <span>
                      {Number(location.capacity) === 1
                        ? "1 person"
                        : `Up to ${location.capacity} people`}
                    </span>
                  </>
                )}
              {location.type !== "bundle" && location.type !== "office" && (
                <>
                  <span>
                    {user.current_staff} dedicated desk
                    {user.current_staff > 1 ? "s" : ""}
                  </span>
                  <span className={"d-md-none"}>
                    {pricePerDesk(location, user.current_staff)}/desk
                  </span>
                </>
              )}

              {location.availability &&
                location.availability !== true &&
                moment(location.availability).isAfter(moment()) && (
                  <span>
                    Available{" "}
                    {moment(location.availability).isValid()
                      ? moment(location.availability).format("MMMM Do")
                      : moment().format("MMMM Do")}
                  </span>
                )}
            </p>

            <p className="price-block">
              <>
                {displayPrice && (
                  <>
                    {location.type === "dedicated desk" && (
                      <span className={"d-none d-md-block"}>
                        <strong>
                          {pricePerDesk(location, user.current_staff)}
                        </strong>
                        /desk
                      </span>
                    )}

                    {location.type === "dedicated desk" ? (
                      priceRange(location)
                    ) : (
                      <strong>{mapPrice(location.results, isDaily)}</strong>
                    )}
                  </>
                )}

                {!displayPrice ? (
                  <span>Contact for pricing</span>
                ) : (
                  <>
                    {location.type === "dedicated desk" ? " total" : "/month"}
                  </>
                )}
              </>
            </p>
          </div>
        </div>
      </div>
    </ProfileLink>
  )
}

export default ApiLocationBlock

const ProfileLink = ({ children, ...props }) => {
  const chromeInIos =
    typeof navigator !== "undefined" &&
    navigator.userAgent.indexOf("CriOS") >= 0

  if (chromeInIos) {
    return <a {...props}>{children}</a>
  }
  return (
    <a {...props} rel="noopener noreferrer">
      {children}
    </a>
  )
}

export const profileUrl = (id, user) => {
  const link = {
    team_size: user.team_size,
    move_in_date: user.move_in_date,
    space_type: user.offices ? "Private Office" : "Dedicated Desk",
    profile_type: "Monthly Spaces",
  }
  return `/space/${id}?${qs.stringify(link)}`
}
